import { useCallback } from 'react';
import useManagerValue from './useManagerValue';
import useAppStateManager from './useAppStateManager';
export default (function (name) {
  var _manager$getSetter;
  var manager = useAppStateManager();
  var value = useManagerValue({
    eventName: "".concat(name, "Change"),
    getFunction: useCallback(function () {
      var _manager$get;
      return manager === null || manager === void 0 || (_manager$get = manager.get) === null || _manager$get === void 0 ? void 0 : _manager$get.call(manager, name);
    }, [name]),
    manager: manager
  });
  return [value, manager === null || manager === void 0 || (_manager$getSetter = manager.getSetter) === null || _manager$getSetter === void 0 ? void 0 : _manager$getSetter.call(manager, name)];
});